const getTotalByItems = (items: IItemTaxOperation[]) => {
  return items.reduce((acc, item) => {
    const itemTotal = item.amount * item.quantity - (item.discount || 0)
    return acc + itemTotal
  }, 0)
}

const getTaxRetainByItems = (
  items: IItemTaxOperation[],
  taxConfig: ITaxConfigurations,
): number => {
  return items.reduce((acc, item) => {
    if (!item.taxRetention?.value) return acc

    const taxRate = Number(item.taxRetention.value)
    const total = getTotalByItems([item])

    const tax = getTaxByItem(total, item.metadata.product.taxRate, taxConfig)

    let gravable: number
    if (taxConfig.taxIncluded) gravable = total - tax
    else gravable = total

    return acc + gravable * taxRate
  }, 0)
}

const getTaxByItems = (
  items: IItemTaxOperation[],
  taxConfig: ITaxConfigurations,
): number => {
  return items.reduce((acc, item) => {
    const { taxRate } = item.metadata.product
    const total = getTotalByItems([item])

    const tax = getTaxByItem(total, taxRate, taxConfig)
    return acc + tax
  }, 0)
}

const getTaxByItem = (
  amount: number,
  taxRate: number,
  { taxIncluded, taxDetailed }: ITaxConfigurations,
): number => {
  let tax: number
  if (taxIncluded) tax = amount - amount / (1 + taxRate)
  else if (taxDetailed) tax = amount * taxRate
  else tax = 0

  return tax
}

const calculateSubtotals = (
  items: IItemTaxOperation[],
  taxConfig: ITaxConfigurations,
): ITaxOperationSubtotal[] => {
  const response: ITaxOperationSubtotal[] = []

  let total = getTotalByItems(items)

  response.push({
    label: 'Total',
    amount: total,
  })

  if (taxConfig.taxDetailed) {
    const taxes = getTaxByItems(items, taxConfig)
    response.push({
      label: 'Impuestos',
      amount: taxes,
    })
    total = total + taxes
    response.push({
      label: 'Gran Total',
      amount: total,
    })
  }

  const taxesToExempt = getTaxByItems(
    items.filter(i => i.taxException),
    taxConfig,
  )
  if (taxesToExempt > 0) {
    response.push({
      label: 'Impuestos Exentos',
      amount: taxesToExempt,
    })
    total = total - taxesToExempt
    response.push({
      label: 'Gran Total con Exenciones',
      amount: total,
    })
  }

  const taxesToRetain = getTaxRetainByItems(
    items.filter(i => i.taxRetention?.value),
    taxConfig,
  )

  if (taxesToRetain > 0) {
    response.push({
      label: 'Impuestos retenidos',
      amount: taxesToRetain,
    })
    total = total - taxesToRetain
    response.push({
      label: 'Gran Total con retenciones',
      amount: total,
    })
  }

  return response
}

export { getTotalByItems, getTaxByItems, getTaxRetainByItems, calculateSubtotals }
